import { render, staticRenderFns } from "./AgregaDocumentoDialogComponent.vue?vue&type=template&id=e5d3057c"
import script from "./AgregaDocumentoDialogComponent.vue?vue&type=script&lang=js"
export * from "./AgregaDocumentoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports